import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import VueStateManager from './infrastructure/state/vue-state-manager';
import {
  AllianzEarningsReportHttpRepository,
  AllianzEarningsReportDummyRepository,
} from './infrastructure/repository';

// Application
import { SearchAllianzEarningsReportQuery } from './application/queries';

// Domain
import { AllianzEarningsReportRepository } from './domain/repository';
import { StateManager } from './domain/state/state-manager';

export default function setupAllianzEarningsReport(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<StateManager>(TYPES.ALLIANZ_EARNINGS_REPORT_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<AllianzEarningsReportRepository>(TYPES.ALLIANZ_EARNINGS_REPORT_REPOSITORY)
    .to(
      withDummies
        ? AllianzEarningsReportDummyRepository
        : AllianzEarningsReportHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<SearchAllianzEarningsReportQuery>(TYPES.SEARCH_ALLIANZ_EARNINGS_REPORT_QUERY)
    .to(SearchAllianzEarningsReportQuery)
    .inSingletonScope();
}
